var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_bnb_50px",
    transform: "translate(-456 -1433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_56",
    "data-name": "\\uD0C0\\uC6D0 56",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(456 1433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "img_bep20",
    transform: "translate(467.539 1444.538)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_186",
    "data-name": "\\uD328\\uC2A4 186",
    d: "M144.98,382.3l-3.261,3.258-3.258-3.258,3.258-3.258Z",
    transform: "translate(-138.462 -367.881)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_187",
    "data-name": "\\uD328\\uC2A4 187",
    d: "M183.21,313.743l5.583,5.586,3.258-3.258-8.84-8.84-8.84,8.84,3.258,3.258Z",
    transform: "translate(-168.787 -307.23)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_188",
    "data-name": "\\uD328\\uC2A4 188",
    d: "M285.37,379.046l-3.258,3.258,3.258,3.258,3.255-3.258Z",
    transform: "translate(-259.778 -367.881)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_189",
    "data-name": "\\uD328\\uC2A4 189",
    d: "M183.21,420.555l-5.583-5.583-3.258,3.255,8.84,8.84,8.84-8.84-3.258-3.255Z",
    transform: "translate(-168.787 -398.221)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_168",
    "data-name": "\\uC0AC\\uAC01\\uD615 168",
    width: 4.607,
    height: 4.607,
    transform: "translate(11.165 14.423) rotate(-45)",
    fill: "#f0b90b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.2831f11e.svg";
export { ForwardRef as ReactComponent };